import Action from "../actions";

export function confirmDialogReducer(state =
                                         {
                                             isShowing: false,
                                             title: '',
                                             body: '',
                                             buttonType: 1,
                                             buttonCancelLabel: 'Hủy bỏ',
                                             buttonConfirmLabel: 'Xác nhận',
                                             showCloseButton: true,
                                             confirmCallback: null,
                                             cancelCallback: null
                                         }
    , action) {

    if (action.type === Action.SHOW_CONFIRMATION_DIALOG) {
        return action.dialog;
    }
    return state;
}
